import getTcfConsent from './tcfv2';
import amaLog from '../helpers/log';
import { timeFor } from '../helpers/time';
import { hasTcfConsent } from './tcfv2';

export const checkForUserConsent = async (): Promise<boolean> => {
  if (
    typeof window !== 'undefined' &&
    window.userConsent &&
    typeof window.userConsent.isTargetingApproved === 'function'
  ) {
    return new Promise((resolve) => {
      window.userConsent.isTargetingApproved((response: any) => {
        resolve(response ? true : false);
      });
    });
  } else {
    return false;
  }
};

const getConsent = async (): Promise<boolean | undefined> => {

  try {
    amaLog('Get tcf consent ...');

    const { tcData } = await getTcfConsent();

    amaLog(`Got tcf consent ${timeFor("getTcfConsent")} `, tcData);

    const hasConsent = (await checkForUserConsent()) || hasTcfConsent(tcData);

    amaLog(`hasConsent: ${hasConsent}`);

    return hasConsent;
  } catch (e) {
    console.error('Unable to retrieve tcf consent');
  }
};

export default getConsent;
